import type {
  LocalAgentBridgeLifecyclePayload,
  LocalAgentBridgeProgressPayload,
  LocalAgentBridgeRequest,
  LocalAgentBridgeResponse,
  LocalAgentLifecycleEventType,
} from './local-agent-protocol'

export const LOCAL_AGENT_NODE_DEFAULT_PORT = 4174
export const LOCAL_AGENT_NODE_DEFAULT_BASE_URL = `http://127.0.0.1:${LOCAL_AGENT_NODE_DEFAULT_PORT}`
export const LOCAL_AGENT_NODE_DEFAULT_POLL_TIMEOUT_MS = 15_000
export const LOCAL_AGENT_NODE_DEFAULT_REQUEST_TIMEOUT_MS = 60_000
export const LOCAL_AGENT_NODE_DEFAULT_SESSION_TTL_MS = 30_000

export interface LocalAgentNodeSessionLifecycleSnapshot {
  type: LocalAgentLifecycleEventType
  currentProjectId: string | null
  currentWorkspaceName: string | null
  currentEditorWorkspace: string | null
  isUserSignedIn: boolean
  subscriptionTier: string | null
  protocolVersion: string
}

export interface LocalAgentNodeSessionRegistrationRequest {
  sessionId: string
  appOrigin: string
  appVersion: string
  lifecycle: LocalAgentNodeSessionLifecycleSnapshot
}

export interface LocalAgentNodeSessionRegistrationResponse {
  ok: true
  sessionId: string
  pollTimeoutMs: number
}

export interface LocalAgentNodeSessionLifecycleRequest {
  sessionId: string
  lifecycle: LocalAgentBridgeLifecyclePayload
}

export interface LocalAgentNodeSessionPollResponse {
  ok: true
  sessionId: string
  request: LocalAgentBridgeRequest | null
}

export interface LocalAgentNodeSessionResponseRequest {
  sessionId: string
  response: LocalAgentBridgeResponse
}

export interface LocalAgentNodeSessionProgressRequest {
  sessionId: string
  progress: LocalAgentBridgeProgressPayload
}
